export default "__VITE_ASSET__141cd65b__"